import * as React from 'react';
import { Box, Typography, Paper, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface SuccessStepProps {
  result?: {
    trafficSource?: {
      _id: string;
      name?: string;
    };
    campaign?: {
      _id: string;
      name?: string;
    };
  };
}

function SuccessStep({ result }: SuccessStepProps) {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
        <CheckCircleIcon color="success" sx={{ fontSize: 40 }} />
        <Typography variant="h6">
          Wizard Completed Successfully!
        </Typography>
      </Box>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Your offer, traffic source, and campaign have been created. You can now view and manage them using the links below.
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {result?.trafficSource && (
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Traffic Source
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {result.trafficSource.name || 'Traffic Source'}
            </Typography>
            <MuiLink
              component={Link}
              to={`/traffic/${result.trafficSource._id}`}
              underline="hover"
            >
              View Traffic Source →
            </MuiLink>
          </Paper>
        )}

        {result?.campaign && (
          <Paper sx={{ p: 2 }}>
            <Typography variant="subtitle2" gutterBottom>
              Campaign
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              {result.campaign.name || 'Campaign'}
            </Typography>
            <MuiLink
              component={Link}
              to={`/campaigns/${result.campaign._id}/offers`}
              underline="hover"
            >
              View Campaign →
            </MuiLink>
          </Paper>
        )}
      </Box>
    </Box>
  );
}

export default SuccessStep;

